// extracted by mini-css-extract-plugin
module.exports = {"refundability-content":"FarePriceHeader_refundability-content__y0QtB","refundabilityContent":"FarePriceHeader_refundability-content__y0QtB"};